import { getInstance } from "public/Utilities/subscription";
import { postInstance, setWidget, getFreeShippingLimits, getHighPricedProducts } from 'backend/api.web.js';
import wixWindowFrontend from 'wix-window-frontend';
import { setupUI } from 'public/Shared/helper.js';
import wixWidget from 'wix-widget';
import store from 'store';
import WixEcomBackend from 'wix-ecom-backend';

export async function initialLoading() {
    await fetchMainData('design');
    const props = await store.get('props');
    await setupUI(props);
}

export async function handleOnPropsChanged(newProps) {
    await setupUI(newProps);
}

export async function handleOnCartChange() {
    let cartDetails;
    try {
        cartDetails = await WixEcomBackend.currentCart.estimateCurrentCartTotals();
    } catch (error) {
        cartDetails = [];
    }
    store.set('cartDetails', cartDetails);
    const props = await store.get('props');
    await setupUI(props);
}

// Handling fetch main data
export async function fetchMainData(code = 'panel') {

    try {
        //Get the props and set them to store 
        const props = code === 'panel' ? await wixWidget.getProps() : $widget.props;
        store.set('props', props);

        //Get the viewMode and set them to store 
        const { viewMode } = wixWindowFrontend;
        store.set('viewMode', viewMode);

        //Get the formFactor and set them to store 
        const { formFactor } = wixWindowFrontend;
        store.set('formFactor', formFactor);

        //Get the instance and set them to store 
        const instance = await getInstance();
        store.set('instance', instance);

        //Call update Instance 
        await postInstance(instance.instanceId);
        await setWidget(instance.instanceId, viewMode);

        // let shippingLimits = await getFreeShippingLimits(instance.instanceId);
        let widgetActiveStatus = props.showHideWidgetToggleValue;
        let minimumCartValue = props.progressBarMinCartValue;

        let shippingLimits = {
            active: widgetActiveStatus,
            limit: minimumCartValue,
        }

        store.set('shippingLimits', shippingLimits);

        let cartDetails;
        try {
            cartDetails = await WixEcomBackend.currentCart.estimateCurrentCartTotals();
        } catch (error) {
            cartDetails = [];
        }
        store.set('cartDetails', cartDetails);

        //Get General Product Details
        let generalProduct = await getHighPricedProducts(1);
        store.set('generalProduct', generalProduct);

    } catch (error) {
        // Handle and log any errors that may occur during the fetch process.
        console.error('⬇️ fetchMainData ~ error: ', error);

        // Return null in case of an error.
        return null;
    }
}
// Handling fetch main data
export async function fetchNewData(code = 'panel') {

    try {
        //Get the props and set them to store 
        const props = code === 'panel' ? await wixWidget.getProps() : $widget.props;
        store.set('props', props);

        // let shippingLimits = await getFreeShippingLimits(instance.instanceId);
        let widgetActiveStatus = props.showHideWidgetToggleValue;
        let minimumCartValue = props.progressBarMinCartValue;

        let shippingLimits = {
            active: widgetActiveStatus,
            limit: minimumCartValue,
        }

        store.set('shippingLimits', shippingLimits);

    } catch (error) {
        // Handle and log any errors that may occur during the fetch process.
        console.error('⬇️ fetchMainData ~ error: ', error);

        // Return null in case of an error.
        return null;
    }
}